export const paymentBrands = [
  'visa',
  'mastercard',
  'neosurf',
  'bank-transfer',
  'skrill',
  'neteller',
];

export const brandSizeMap = {
  visa: { width: 80, height: 26 },
  mastercard: { width: 52, height: 32 },
  neosurf: { width: 106, height: 32 },
  bankTransfer: { width: 105, height: 32 },
  skrill: { width: 75, height: 32 },
  neteller: { width: 144, height: 30 },
};

export const getBrandKey = (brand: string): keyof typeof brandSizeMap => {
  const lower = brand.toLowerCase();
  if (lower.includes('visa')) return 'visa';
  if (lower.includes('mastercard')) return 'mastercard';
  if (lower.includes('neosurf')) return 'neosurf';
  if (lower.includes('bank-transfer')) return 'bankTransfer';
  if (lower.includes('skrill')) return 'skrill';
  if (lower.includes('neteller')) return 'neteller';
  return 'visa';
};
